import EntityGestionnaireRow from '@/pages/Entity/components/Rows/EntityGestionnaireRow';
import ContactModel           from '@/models/services/network/ContactModel';
import { Box }                from '@chakra-ui/react';
import { Text }               from '@chakra-ui/react';
import { useTranslation }     from 'react-i18next';

interface IEntityGestionnaireBoxProps {
	contact: ContactModel | undefined;
}

const EntityGestionnaireBox = ({ contact }: IEntityGestionnaireBoxProps) => {
	const { t } = useTranslation();

	return (
		<Box
			backgroundColor="white"
			borderRadius="md"
			boxShadow="md"
			padding="20px"
			flex="1"
			minWidth="280px"
		>
			<Text className="poppins-semibold" fontSize="16px" mb="15px">
				{t('pages.entity.gestionnaire.title')}
			</Text>

			{contact ? (
				<EntityGestionnaireRow name={contact.fullName} email={contact.email} photoUrl={contact.photoUrl} />
			) : (
				<Text fontSize="14px" color="gray.400">{t('pages.entity.gestionnaire.empty')}</Text>
			)}
		</Box>
	);
};

export default EntityGestionnaireBox;
